import { cardStyles } from './card.styles';
import { attr, FASTElement } from '@microsoft/fast-element';
import { NatGenDesignSystem } from '../../natgen-design-system';
import { cardTemplate } from './card.template';

/**
 * @element natgen-card
 */
export class NatGenCard extends FASTElement {}

export const natGenCardDefinition = NatGenCard.compose({
    name: `${NatGenDesignSystem.prefix}-card`,
    template: cardTemplate(),
    styles: cardStyles
});
